export const sidebarPanelRoles = {

    MAP_MODULES_LIST: "map-modules-list",
    MAP_MODULE_INFO: "map-module-info",
    FEATURE_INFO: "feature-info"

}